import { useState } from 'react';
import PropTypes from 'prop-types';

import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import Dropzone from 'react-dropzone';

import Message from 'uI/Message/Message';

import { getAwsCredentials } from 'store/myAccount-actions';

import classes from './UserImage.module.css';

let file = null;
let fileType = null;
let archive = null;

const UserImage = props => {
  const [openMessage, setOpenMessage] = useState(false);
  const [userNewImage, setUserNewImage] = useState(props.userImage);
  const [showExtraInfo, setShowExtraInfo] = useState(false);

  const showAditionalText = parameter => () => {
    setShowExtraInfo(parameter);
  };

  const onDrop = filesOnDrop => {
    setOpenMessage(true);
    archive = filesOnDrop[0];
    file = filesOnDrop[0].name;
    file.toString();
    file = file.replace(/[^a-z0-9.]+/gi, '_').toLowerCase();
    fileType = 'image/*';
    (async () => {
      setUserNewImage(
        await getAwsCredentials('myProfile', file, fileType, archive)
      );
      setOpenMessage(false);
    })();
  };

  return (
    <>
      <Dropzone
        className={classes.changeImageContainer}
        onDrop={onDrop}
        accept=".jpg, .png"
      >
        <figure className={classes.userImgContainer}>
          <img
            onMouseOver={showAditionalText(true)}
            onMouseLeave={showAditionalText(false)}
            id="myProfileImage"
            className={classes.userImg}
            src={
              props.userImage
                ? userNewImage
                : 'https://d1g6c01s9ssd7h.cloudfront.net/img/usuario12.png'
            }
            alt="image user"
          />
        </figure>
        <div
          onMouseOver={showAditionalText(true)}
          onMouseLeave={showAditionalText(false)}
          className={
            showExtraInfo
              ? classes.showChangeImageText
              : classes.hideChangeImageText
          }
        >
          <AddPhotoAlternateIcon style={{ marginTop: 10 }} />
          <p style={{ fontSize: 12, marginTop: 0 }}>Editar Imagen</p>
        </div>
      </Dropzone>
      {openMessage && (
        <Message
          openDialog={openMessage}
          message="Tu imagen está siendo procesada, espera un momento por favor"
          loading
        />
      )}
    </>
  );
};

UserImage.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userImage: PropTypes.array
};

export default UserImage;
